const BonusCategory = () =>
    import("@/views/bonusCategory/BonusCategory");

const BonusCategoryList = () =>
    import("@/views/bonusCategory/BonusCategoryList");

const LiquidationQuery = () =>
    import("@/views/bonusCategory/LiquidationQuery");

const PreliquidationGeneration = () =>
    import("@/views/bonusCategory/PreliquidationGeneration");

const PreliquidationApproval = () =>
    import("@/views/bonusCategory/PreliquidationApproval");

export const BonusCategoryListRoute = {
    path: "bonusCategoryList",
    component: BonusCategoryList,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",      
        breadcrumb: [
            {
                text: "Bonos por Categoría",
                disabled: true,
                href: "#"
            },
            {
                text: "Consulta",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};

export const LiquidationQueryRoute = {
    path: "liquidationQuery",
    component: LiquidationQuery,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",
        breadcrumb: [
            {
                text: "Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Consulta de liquidaciones",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};

export const PreliquidationGenerationRoute = {
    path: "preliquidationGeneration",
    component: PreliquidationGeneration,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
            {
                text: "Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Generacion de preliquidación",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};

export const PreliquidationApprovalRoute = {
    path: "preliquidationApproval",
    component: PreliquidationApproval,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",  
        breadcrumb: [
            {
                text: "Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Aprobación de preliquidaciones",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};


export const BonusCategoryRoute = {
    path: "bonusCategory",
    component: BonusCategory,
    children: [

        BonusCategoryListRoute,
        LiquidationQueryRoute,
        PreliquidationGenerationRoute,
        PreliquidationApprovalRoute,
    ]
}